import { useCallback } from 'react';
import {
  useQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  OperationVariables,
  QueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/GetAdvertiserSettingsInfo.graphql';
import { Query } from '../../__generated__/globalTypes';

export const useGetAdvertiserSettingsInfoQuery = (options?: QueryHookOptions<Query>) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useGetAdvertiserSettingsInfoLazyQuery = (
  options?: LazyQueryHookOptions<Query>
): QueryResult<Query> & { getGetAdvertiserSettingsInfoQuery: LazyQueryExecFunction<Query, OperationVariables> } => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  // TODO: should be getGetAdvertiserSettingsInfo
  const [getGetAdvertiserSettingsInfoQuery, result] = useLazyQuery<Query>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getGetAdvertiserSettingsInfoQuery, ...result };
};

export const useGetAdvertiserSettingsInfoPromiseQuery = () => {
  const client = useApolloClient();

  const getGetAdvertiserSettingsInfo = useCallback(
    (options?: Omit<QueryOptions<Record<string, unknown>, Query>, 'query'>) =>
      client.query<Query>({ ...options, query: QUERY }),
    [client]
  );

  return { getGetAdvertiserSettingsInfo };
};
